import type { BookPageTranslations, RoomBeddingConfigKey } from "@/data/book-page-i18n";
import type { RoomMetadata } from "@/data/room-metadata";

type BookingRoomLike = {
  displayName: string;
  sourceRoom: { id: string; shortDescription: string };
};

export function getLocalizedBookRoomDisplay(
  room: BookingRoomLike,
  meta: RoomMetadata | undefined,
  book: BookPageTranslations,
): { displayName: string; description: string } {
  const row = book.roomLadder[room.sourceRoom.id as keyof typeof book.roomLadder];
  const displayName = row?.displayName ?? room.displayName;
  const description =
    row?.description ?? meta?.descriptionHighlight ?? room.sourceRoom.shortDescription;
  return { displayName, description };
}

/** Maps `Room.bedding.configuration` (English key from `rooms.ts`) to the active language. */
export function getLocalizedBeddingConfiguration(
  configuration: string,
  book: BookPageTranslations,
): string {
  const labels = book.roomCard.beddingLabels;
  if (configuration in labels) {
    return labels[configuration as RoomBeddingConfigKey];
  }
  return configuration;
}

/** Book page room cards: per-room overrides then default bedding label. */
export function getBookPageBeddingLabel(
  localRoomId: string,
  beddingConfiguration: string,
  book: BookPageTranslations,
): string {
  if (localRoomId === "family-suite") {
    return book.roomCard.familySuiteBedding;
  }
  return getLocalizedBeddingConfiguration(beddingConfiguration, book);
}

export function getLocalizedUpsellCopy(
  upsellId: string,
  fallback: { name: string; description: string },
  book: BookPageTranslations,
): { name: string; description: string } {
  const row = book.upsells[upsellId as keyof typeof book.upsells];
  return {
    name: row?.name ?? fallback.name,
    description: row?.description ?? fallback.description,
  };
}
